var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pdfSrc)?_c('div',[_c('PDFViewer',{staticStyle:{"height":"100vh","width":"100vw"},attrs:{"source":_vm.pdfSrc},on:{"download":_vm.handleDownload}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }